var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"hide-details":"","label":"Insertion Length","suffix":"cm","value":_vm.data},on:{"change":function($event){return _vm.$emit('change', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }